import { render, staticRenderFns } from "./titleBorder.vue?vue&type=template&id=1a8771ba&scoped=true&"
import script from "./titleBorder.vue?vue&type=script&lang=js&"
export * from "./titleBorder.vue?vue&type=script&lang=js&"
import style0 from "./titleBorder.vue?vue&type=style&index=0&id=1a8771ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8771ba",
  null
  
)

export default component.exports